import detectBrowser from './utils/detectBrowser';
import isMobile from './utils/isMobile';
import removeHoverOnMobile from './utils/removeHoverOnMobile';
import App from './modules/app';
import Scroll from './modules/scroll';
import VideoLoad from './modules/video-loader';
import Show from './modules/article';
import Tabs from './modules/tabs';
import SelectMedia from './modules/select-media';
import SearchPopup from './modules/search-popup';
import RemoveItems from './modules/remove-and-add-items';
import Tags from './modules/tag';
import MySlider from './modules/slick';

import './components/form-submit-tweaks';


// TODO: fnid what these two were used on?
// import './vendor/canvasFirefly';
// import SwiperInit from './modules/swiper';

$(document).ready(() => {
    detectBrowser();
    removeHoverOnMobile();

    const AppModule = new App();
    AppModule.init();

    const ScrollModule = new Scroll();
    ScrollModule.init();

    const SearchPopupModule = new SearchPopup();
    SearchPopupModule.init();

    const VideoLoadModule = new VideoLoad();
    VideoLoadModule.init();

    const ShowModule = new Show();
    ShowModule.init();

    const Tab = new Tabs();
    Tab.init();

    const Select = new SelectMedia();
    Select.init();

    // const Swiper = new SwiperInit();
    // Swiper.init();

    const RemoveItem = new RemoveItems();
    RemoveItem.init();

    const Tag = new Tags();
    Tag.init();

    const Slider = new MySlider();
    Slider.init();


    if (isMobile()) {
        $('body').addClass('mobile');
    }

    $('.mobile-header--menu-trigger').on('touchend', () => {
        $('body').toggleClass('mobile-menu-is-visible');
    })

    $('.menu-item-has-children > a').on('click', (e) => {
        $(e.currentTarget).closest('.menu-item-has-children').toggleClass('submenu-is-active');
        return false;
    })

    const resizeVh = () => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${ vh }px`);
    }

    resizeVh();

    $(window).on('resize orientationchange', resizeVh);

    $(document).on('click', '[data-stop-propagation]', (e) => {
        e.stopPropagation();
    });

    $(document).on('click', '[data-toggle-body-class]', (e) => {
        e.preventDefault();
        $('body').toggleClass($(e.currentTarget).attr('data-toggle-body-class'));
    });

    $(document).on('change', '.js-submit-on-change', (e) => {
        $(e.currentTarget).closest('form').submit();
    });

    $(document).on('click', '.js-open-share-window', (e) => {
        e.preventDefault();
        window.open(e.currentTarget.href,
            '',
            'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
        );
    });

    if (window.localStorage.getItem('go-back-page')) {
        $('.js-back-to-referrer').attr('href', window.localStorage.getItem('go-back-page'));
        window.localStorage.removeItem('go-back-page');
    }

    $(document).on('click', '.js-save-go-back-page', (e) => {
        window.localStorage.setItem('go-back-page', window.location.href);
    });


    setTimeout(() => {
        $('.elementor-tab-title').removeClass('elementor-active');
        $('.elementor-tab-content').css('display', 'none');
    }, 100);


    const notifications = $('#template-notices');

    if (notifications.length) {
        $('body, html').animate({
            scrollTop: notifications.position().top
        })
    }
});
